export const image = "image";
export const video = "video";
